import './hot.js';
import 'whatwg-fetch';
import { createRoot } from 'react-dom/client';
import { AG_GRID_LICENSE } from '../injectedConstants.js';
import { getSentryClient } from './sentry.js';
import { getOrganizationSettings } from './organizationSettings.js';

const container = document.getElementById('root');

if (container != null) {
  Promise.resolve(getOrganizationSettings())
    .then(async (organizationSettings) => {
      if (organizationSettings == null) {
        throw new Error('getOrganizationSettings error');
      }
      return organizationSettings;
    })
    .then((organizationSettings) => {
      return Promise.resolve(getSentryClient()).then(() => {
        return organizationSettings;
      });
    })
    .then((organizationSettings) => {
      return Promise.all([
        import('ag-grid-community'),
        import('ag-grid-enterprise'),
        import('./i18n.js'),
      ]).then((modules) => {
        return { organizationSettings, modules };
      });
    })
    .then(
      async ({
        organizationSettings,
        modules: [agGridCommunity, agGridEnterprise, i18n],
      }) => {
        // Register all community and enterprise features
        // It must be registered before importing the render function
        agGridCommunity.ModuleRegistry.registerModules([
          agGridCommunity.AllCommunityModule,
          agGridEnterprise.AllEnterpriseModule,
        ]);

        // Mark all grids as using legacy themes
        agGridCommunity.provideGlobalGridOptions({
          theme: 'legacy',
        });

        if (AG_GRID_LICENSE != null && AG_GRID_LICENSE.trim() !== '') {
          agGridEnterprise.LicenseManager.setLicenseKey(AG_GRID_LICENSE);
        }
        return Promise.all([
          import('react'),
          i18n.initI18n(organizationSettings),
        ]).then(([react]) => {
          return { react };
        });
      },
    )
    .then(({ react }) => {
      const AppWrapper = react.lazy(async () => {
        return import('./AppWrapper.js');
      });
      const root = createRoot(container);
      root.render(<AppWrapper />);
    })
    .catch((error) => {
      getSentryClient()?.captureException(error);
    });
}
